import { HTMLChakraProps, forwardRef } from '@chakra-ui/react-v2';
import { chakra } from '@chakra-ui/react-v2';

import { useMessageGroupStyles } from '../useMessageGroupStyles';

export type ConversationUserMessageProps = HTMLChakraProps<'div'>;

export const ConversationUserMessage: React.FC<ConversationUserMessageProps> =
  forwardRef<ConversationUserMessageProps, 'div'>(
    ({ children, ...props }, ref) => {
      const { userMessage } = useMessageGroupStyles();

      return (
        <chakra.div
          sx={userMessage}
          className="message-group-user-message"
          {...props}
          ref={ref}
        >
          {children}
        </chakra.div>
      );
    },
  );
ConversationUserMessage.displayName = 'ConversationUserMessage';
